import React from 'react';

interface FooterProps {}

const Footer: React.FC<FooterProps> = () => {
  const year = new Date().getFullYear();
  
  return (
    <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 py-4 mt-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="text-sm text-gray-600 dark:text-gray-400">
            © {year} Get Deleto - Write continuously or lose your work
          </div>
          
          <div className="flex items-center mt-2 md:mt-0">
            <div className="flex space-x-4 text-sm text-gray-600 dark:text-gray-400">
              <a 
                href="/privacy" 
                className="hover:text-primary hover:underline"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.hash = '#/privacy';
                }}
              >
                Privacy Policy
              </a>
              <a 
                href="/terms" 
                className="hover:text-primary hover:underline"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.hash = '#/terms';
                }}
              >
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 